/* eslint-disable */
import { http } from '@/helpers/http';
import { transformDateToSend, transformDateView } from '@/helpers/transformDates';

const defaultPost = {
  id: 'new',
  title: '',
  alias: '',
  views_count: 0,
  views_count_real: 0,
  original_image: null,
  preview_text: '',
  detail_text: '',
  updated_at: '',
  created_at: '',
  is_active: false,

  // Вкладка SEO
  seo_title: '',
  seo_description: '',
  seo_keywords: '',
};

export default {
  namespaced: true,
  state() {
    return {
      list: [], // Список
      search: '', // Поисковое слово в списке
      current: defaultPost,
    };
  },

  mutations: {
    /* Записать новый список */
    setList (state, data) {
      state.list = data.slice();
    },

    /* Установить поисковое слово */
    setSearch (state, data) {
      state.search = data;
    },

    /* Установить свойство текущего объекта */
    setValue (state, payload) {
      state.current = {
        ...state.current,
        ...payload
      }
    },

    /** Добавить картинку в галерею, вроде не нужен метод так как можно сделать через setValue */
    // addImage(state, payload) {
    //   state.current.gallery.push(payload);
    // },

    /* Очистить текущее значение */
    clearCurrent (state) {
      state.current = {
        ...state.current,
        ...defaultPost
      }
    },

    /* Удалить из списка */
    removeFormList (state) {
      const index = state.list.findIndex(({id}) => id === state.current.id);
      state.list.splice(index, 1);
    },

    /* Установить текущий объект по идентификатору, используется только для функции копирования */
    setCurrent (state, _id) {
      const post = state.list.find(({ id }) => id === _id )
      console.log("setCurrent -> post", post)
      console.log("setCurrent -> state.current", state.current)
      state.current = {
        ...state.current,
        // ...post,
        original_image: null,
      }
    },

    /* Заменить по идентификатору */
    replaceById (state, current) {
      const index = state.list.findIndex(({ id }) => id === current.id);
      state.list.splice(index, 1, current);
    },

    /* Добавить в список */
    addList (state, current) {
      state.list.push({...current, id: state.list.length + 1 });
    },
  },

  getters: {
    // getList: state => state.list.filter(({ title }) => title.indexOf(state.search) >= 0),

    getList: state => state.list
      .filter((el) => {
        return el.title.toLowerCase().indexOf(state.search.toLowerCase()) >= 0;
      })
      .map(({ id, title, views_count, views_count_real, is_active, created_at_formatted, updated_at }) => {
        return {
          id,
          title,
          views_count,
          views_count_real,
          is_active: is_active ? 'Да' : 'Нет',
          created_at_formatted,
          updated_at: transformDateView(updated_at)
        };
    }),

    getById: state => _id => state.list.find(({ id }) => id === _id ),

    getCurrent: state => state.current,

    getFormatList: (state, getters) => {
      return getters.getList.map(obj => ({
        ...obj,
        is_active: obj.is_active ? 'Да' : 'Нет'
      }))
    }
  },

  actions: {
    async getList({ commit }) {
      try {
        const { data } = await http.get('/admin/posts');
        console.log('data', data)
        commit('setList', data);
      } catch (e) {
        throw e;
      }
    },

    async remove({ commit }, id) {
      await http.delete(`/admin/posts/${id}`);
      commit('clearCurrent');
    },

    async getById({ commit }, id) {
      console.log('getById', id)
      if (id === null || id === 'new') {
        commit('clearCurrent');
        return;
      }

      const { data } = await http.get(`/admin/posts/${id}`);
      console.log("getById -> data", data)
      commit('setValue', {
        ...data,
      });
    },

    async save({ state }) {
        // Это новый элемент или редактирование?
        const isNew = state.current.id === 'new' || state.current.id === null;
        console.log("save -> state.current",  state.current)
        console.log("isNew", isNew)


        if (!isNew) {
          const { data: id } = await http.put(`/admin/posts/${state.current.id}`, {
            id: state.current.id,
            is_active: state.current.is_active,
            title: state.current.title,
            alias: state.current.alias,
            views_count: state.current.views_count,
            original_image: state.current.original_image,
            preview_text: state.current.preview_text,
            detail_text: state.current.detail_text,
            seo_description: state.current.seo_description,
            seo_keywords: state.current.seo_keywords,
            seo_title: state.current.seo_title
          });
          console.log('id', id)
          //console.log('data', data)
          return id;
        } else {
          const { data: id } = await http.post('/admin/posts/create', {
            is_active: state.current.is_active,
            title: state.current.title,
            alias: state.current.alias,
            views_count: state.current.views_count,
            original_image: state.current.original_image,
            preview_text: state.current.preview_text,
            detail_text: state.current.detail_text,
            seo_description: state.current.seo_description,
            seo_keywords: state.current.seo_keywords,
            seo_title: state.current.seo_title
          });
          return id;
        }
    }
  },
};
